var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var initState = {
  compiling: false,
  showSider: false,
  themeMode: 'light',
  docs: {},
  showConfigProvider: false
};
var ThemeReducer = function ThemeReducer(state, action) {
  if (state === void 0) {
    state = initState;
  }
  var payload = action.payload;
  switch (action.type) {
    case 'setShowSider':
      return __assign(__assign({}, state), {
        showSider: payload
      });
    case 'updateThemeConfig':
      return __assign(__assign({}, state), {
        themeConfig: __assign(__assign({}, state.themeConfig), payload)
      });
    case 'setThemeMode':
      return __assign(__assign({}, state), {
        themeMode: payload
      });
    case 'setDocs':
      {
        return __assign(__assign({}, state), {
          docs: payload.reduce(function (total, next) {
            next.key && (total[next.key] = next);
            return total;
          }, {})
        });
      }
    case 'setConfigProvider':
      return __assign(__assign({}, state), {
        showConfigProvider: payload
      });
    default:
      return state;
  }
};
export default ThemeReducer;